import { MRT_Row } from '@talentmesh/table';
import { useAiSearchProfilePopoutContext } from '../../../AiSearchProfilePopout/AiSearchProfilePopoutContext';
import { ShortlistedProfile } from '@/Pages/Candidates/AiSearch/api/DTO/ShortlistedProfile';
import UIStrings from '@/Utils/UIStrings';

interface EmailRepliedCellProps {
    row: MRT_Row<ShortlistedProfile>;
}

const EmailRepliedCell = ({ row }: EmailRepliedCellProps) => {
    const { openProfilePopout } = useAiSearchProfilePopoutContext();
    const { id, profile, searchCriteriaScores, repliedAt, emailSentCount } = row.original;

    const handleOnClick = () => {
        openProfilePopout({
            id,
            education: profile.education,
            experience: profile.experience,
            location: profile.location,
            name: profile.name,
            about: profile.about,
            url: profile.url,
            searchCriteriaScores,
            languages: profile.languages,
            emailSentCount,
        });
    };

    if (!repliedAt) {
        return <p className="mx-auto overflow-hidden text-sm text-ellipsis">-</p>;
    }

    return (
        <div
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                e.preventDefault();
                if (e.key === 'Enter' || e.key === ' ') {
                    handleOnClick();
                }
            }}
            className="text-primary mx-auto cursor-pointer overflow-hidden text-sm font-bold text-ellipsis"
            onClick={handleOnClick}
        >
            {UIStrings.Replied}
        </div>
    );
};

export default EmailRepliedCell;
